/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Andor application API
 * OpenAPI spec version: v1
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  ConsumeRecoveryBody,
  InspectRecoveryBody,
  RecoveryInspectResponse,
  RecoveryRequestResponse,
  RoleNoPassword,
  SignInBody,
  SignOutBody,
  SignOutResponse
} from '../models';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';

import {
  ANDOR_BASE_URL
} from '../api.base-url';



interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};







@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(ANDOR_BASE_URL);
 consumeRecovery<TData = RoleNoPassword>(consumeRecoveryBody: ConsumeRecoveryBody, options?: HttpClientBodyOptions): Observable<TData>;
 consumeRecovery<TData = RoleNoPassword>(consumeRecoveryBody: ConsumeRecoveryBody, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 consumeRecovery<TData = RoleNoPassword>(consumeRecoveryBody: ConsumeRecoveryBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  consumeRecovery<TData = RoleNoPassword>(
    consumeRecoveryBody: ConsumeRecoveryBody, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/auth/recover`,
      consumeRecoveryBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/auth/recover`,
      consumeRecoveryBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/auth/recover`,
      consumeRecoveryBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 inspectRecovery<TData = RecoveryInspectResponse>(inspectRecoveryBody: InspectRecoveryBody, options?: HttpClientBodyOptions): Observable<TData>;
 inspectRecovery<TData = RecoveryInspectResponse>(inspectRecoveryBody: InspectRecoveryBody, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 inspectRecovery<TData = RecoveryInspectResponse>(inspectRecoveryBody: InspectRecoveryBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  inspectRecovery<TData = RecoveryInspectResponse>(
    inspectRecoveryBody: InspectRecoveryBody, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/auth/recover/inspect`,
      inspectRecoveryBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/auth/recover/inspect`,
      inspectRecoveryBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/auth/recover/inspect`,
      inspectRecoveryBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 requestRecovery<TData = RecoveryRequestResponse>( options?: HttpClientBodyOptions): Observable<TData>;
 requestRecovery<TData = RecoveryRequestResponse>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 requestRecovery<TData = RecoveryRequestResponse>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  requestRecovery<TData = RecoveryRequestResponse>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/auth/recover/request`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/auth/recover/request`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/auth/recover/request`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 signIn<TData = RoleNoPassword>(signInBody: SignInBody, options?: HttpClientBodyOptions): Observable<TData>;
 signIn<TData = RoleNoPassword>(signInBody: SignInBody, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 signIn<TData = RoleNoPassword>(signInBody: SignInBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  signIn<TData = RoleNoPassword>(
    signInBody: SignInBody, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/auth/login`,
      signInBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/auth/login`,
      signInBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/auth/login`,
      signInBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 signOut<TData = SignOutResponse>(signOutBody: SignOutBody, options?: HttpClientBodyOptions): Observable<TData>;
 signOut<TData = SignOutResponse>(signOutBody: SignOutBody, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 signOut<TData = SignOutResponse>(signOutBody: SignOutBody, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  signOut<TData = SignOutResponse>(
    signOutBody: SignOutBody, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/auth/logout`,
      signOutBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/auth/logout`,
      signOutBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/auth/logout`,
      signOutBody,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};
